import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { Text, Textarea as ChakraTextarea, Flex, HStack } from '@chakra-ui/react';
import { TextareaVariant, TextareaSize } from '../../core/enums';
import { styles } from './textarea.styles';
export const Textarea = /*#__PURE__*/ forwardRef(({ leftIcon, onChange, placeholder, readonly, required, rightIcon, value, className = '', disabled = false, maxLength = 2048, size = TextareaSize.MD, variant = TextareaVariant.OUTLINE, ...props }, ref)=>{
    const localRef = useRef(null);
    const [textLength, setTextLength] = React.useState(value?.length ?? 0);
    // Expose the local ref to the parent component
    useImperativeHandle(ref, ()=>localRef.current);
    useEffect(()=>{
        if (localRef.current) {
            localRef.current.focus();
            localRef.current.selectionStart = localRef.current.value.length;
            localRef.current.selectionEnd = localRef.current.value.length;
        }
    }, []);
    return /*#__PURE__*/ _jsxs(HStack, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "left-icon",
                "data-testid": "textarea-left-icon",
                children: leftIcon
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                sx: styles.textarea,
                children: [
                    /*#__PURE__*/ _jsx(ChakraTextarea, {
                        ...props,
                        size: size,
                        isDisabled: disabled,
                        isReadOnly: readonly,
                        isRequired: required,
                        variant: variant,
                        className: className,
                        placeholder: placeholder,
                        value: value,
                        maxLength: maxLength,
                        ref: localRef,
                        onChange: (e)=>{
                            setTextLength(e.target.value.length);
                            onChange?.(e);
                        }
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        sx: styles.lengthIndicator,
                        children: [
                            textLength,
                            "/",
                            maxLength
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "right-icon",
                "data-testid": "textarea-right-icon",
                children: rightIcon
            })
        ]
    });
});
Textarea.displayName = 'Textarea';
